import { DateInput } from '@components/index';
import { memo } from 'react';
import { BigInputDiv, GlobalHeader, InputList } from '../styles';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew } from './utils';

type OwnerShipGroupProps = PropsInputGlobal<'installDate' | 'purchasedDate'>;

export function OwnershipGroup(props: OwnerShipGroupProps) {
  const { setFormV, installDate, purchasedDate, setGlobalFormV } = props;

  return (
    <InputList>
      <BigInputDiv>
        <GlobalHeader>Install Date</GlobalHeader>
        <DateInput
          borderColor="#d8dae5"
          value={installDate ?? null}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeGlobal('installDate', convDate, setGlobalFormV);
            setForAllNew('installDate', convDate, setFormV);
          }}
        />
      </BigInputDiv>
      <BigInputDiv>
        {/* Note: This is the same field as purchasedDate in purchase information */}
        <GlobalHeader>Purchase Date</GlobalHeader>
        <DateInput
          borderColor="#d8dae5"
          value={purchasedDate ?? null}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeGlobal('purchasedDate', convDate, setGlobalFormV);
            setForAllNew('purchasedDate', convDate, setFormV);
          }}
        />
      </BigInputDiv>
    </InputList>
  );
}
export default memo(OwnershipGroup);
